// Based on your existing auth.js but simplified for the test app
const API_BASE_URL = 'https://test-api.rehabilitationhealth.com/api:RIB0KqtX';

class AuthService {
  constructor() {
    this.token = null;
  }

  setToken(token) {
    if (!token) {
      console.warn('Attempted to set null/undefined token');
      return;
    }
    this.token = token;
    localStorage.setItem('auth_token', token);
  }

  getToken() {
    if (!this.token) {
      this.token = localStorage.getItem('auth_token');
    }
    return this.token;
  }

  clearToken() {
    this.token = null;
    localStorage.removeItem('auth_token');
    sessionStorage.removeItem('mfa_verified');
  }

  async exchangeAuth0Tokens(accessToken, idToken) {
    if (!accessToken || !idToken) {
      throw new Error('Missing required tokens for exchange');
    }

    try {
      const url = new URL(`${API_BASE_URL}/oauth/auth0/login`);
      url.searchParams.append('access_token', accessToken);
      url.searchParams.append('id_token', idToken);

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to exchange tokens with backend');
      }

      const data = await response.json();
      
      if (!data.token) {
        throw new Error('No token received from backend');
      }

      this.setToken(data.token);
      return data;
    } catch (error) {
      this.clearToken();
      throw error;
    }
  }

  async getUserProfile() {
    const token = this.getToken();

    if (!token) {
      throw new Error('No authentication token found');
    }

    try {
      const response = await fetch(`${API_BASE_URL}/auth/me`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        this.clearToken();
        throw new Error('Failed to get user profile');
      }

      return await response.json();
    } catch (error) {
      this.clearToken();
      throw error;
    }
  }
  
  // Method to validate biometric authentication
  async validateBiometricAuth(faceScanResult) {
    const token = this.getToken();
    
    if (!token) {
      throw new Error('No authentication token found');
    }
    
    try {
      // This would be your backend endpoint to validate biometric auth
      const response = await fetch(`${API_BASE_URL}/verify-biometric`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
          faceScanResult
        })
      });
      
      if (!response.ok) {
        throw new Error('Biometric verification failed');
      }
      
      return await response.json();
    } catch (error) {
      throw error;
    }
  }
}

export const authService = new AuthService();